module.exports = __webpack_public_path__ + "static/media/17_3.ec7731a4.jpg";